<!--
* UIID: UI-DLB-CT-120
* UI Name: Add Code Group
* Modify Date: 2020/08/06
-->
<template>
  <dialog-drag
    :id="id"
    :ref='"dialog-" + id'
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="dialog-drag-display"
  >
    <!-- [S]  Popup title-->
    <template v-slot:title>
      <v-card-title
        class="headline white--text"
        primary-title
      >{{options.item.action == 'add' ? $t('lbl.dbBroker.addDBBrokerDialog.pageHeaderAdd') : $t('lbl.dbBroker.addDBBrokerDialog.pageHeaderModify')}}</v-card-title>
    </template>
    <template v-slot:button-close>
      <v-btn small text icon @click="removeDialog">
        <icon-svg iconName="close" />
      </v-btn>
    </template>
    <v-row class="ma-0 data-section">
      <v-col cols="12" lg="4" class="pa-0">
        <v-row no-gutters style="height: 100%;">
          <v-col cols="12" lg="10" class="code-table-grid">
            <v-row no-gutters class="mb-2">
              <v-icon x-small>fas fa-asterisk</v-icon>
              <span class="code-group-label">{{$t('lbl.dbBroker.addDBBrokerDialog.codeDBBrokerName')}}</span>
            </v-row>
            <v-row no-gutters class="mb-2">
              <v-text-field
                ref="dbBrokerName"
                v-model="dbBrokerName"
                class="data-table-filter-text-field custom-selectbox find-table-code"
                height="40"
                hide-details
                dense
                solo
                outlined
              ></v-text-field>
            </v-row>
            <v-row v-if="dbBrokerData.length > 0" no-gutters class="mb-0">
              <v-col cols="2" class="pa-0">
                <v-icon class="ma-2" small @click="moveUpQuery" :disabled="selectItemQueryList.length === 0 || selectedItemIndex === 0" color="#5FCBFA">fas fa-caret-up</v-icon>
                <v-icon class="ma-0" small @click="moveDownQuery" :disabled="selectItemQueryList.length === 0 || selectedItemIndex === this.dbBrokerData.length - 1" color="#5FCBFA">fas fa-caret-down</v-icon>
              </v-col>
              <v-col v-if="dbBrokerData[0].dbNm && dbBrokerData[0].queryTp" cols="10" class="pa-0">
                <div class="mt-1">{{dbBrokerData[0].dbNm + ' - ' + dbBrokerData[0].queryTp}}</div>
              </v-col>
            </v-row>
            <v-row no-gutters class="mb-2 vuebar-element db-broker-left-panel">
              <v-col cols="9">
                <v-list nav dense class="code-group-list pt-0" :flat="true" >
                  <v-list-item-group v-model="selectedItemIndex" color="primary">
                    <v-list-item
                      v-for="(item, index) in dbBrokerData"
                      :key="index"
                      @click="selectItemQuery(item)"
                      class="mb-0"
                    >
                      <v-tooltip top>
                        <template v-slot:activator="{on}">
                          <div v-on="on" class="btn-tooltip mr-0">
                            <v-list-item-icon>
                              {{index + 1}}.
                            </v-list-item-icon>
                          </div>
                        </template>
                        <span v-html="$t('lbl.dbBroker.addDBBrokerDialog.tooltipQuerySeq')"></span>
                      </v-tooltip>
                      <v-list-item-content>
                        <a class="group-code-link">{{item.queryNm}}</a>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-col>
              <v-col cols="3">
                <v-list nav dense class="code-group-list pt-0" :flat="true" width="55px">
                  <v-list-item-group color="primary">
                  <v-list-item
                    v-for="(item, index) in dbBrokerData"
                    :key="index"
                    class="mb-0"
                  >
                    <v-list-item-icon @click.stop="confirmDeleteItem(item)">
                      <v-icon x-small class="pa-2">fas fa-times</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                    </v-list-item-content>
                  </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" lg="2" class="pt-0 pb-0 btn-add-code-row">
            <v-btn
              class="btn btn-top btn-search btn-add-code"
              color="primary"
              @click="addDBBroker"
              :disabled="isBtnActive"
            >
              <v-icon :size="20" class="mr-2 ml-2">fas fa-angle-double-left</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" lg="8" class="code-table-grid">
        <v-row class="ma-0">
          <!-- [S]  second table-->
          <v-col cols="12" class="pa-0">
            <v-row class="ma-0">
              <v-col cols="3" class="pa-0 pr-2">
                <v-text-field
                  v-model="searchBy.queryNm"
                  :placeholder="$t('lbl.dbBroker.addDBBrokerDialog.conditionSearch.queryName')"
                  @keyup.enter="getBrokerQueryInfoList"
                  class="data-table-filter-text-field search-button-data-analysis-table"
                  heigth="30"
                  outlined
                  hide-details
                  dense
                  solo
                ></v-text-field>
              </v-col>
              <v-col cols="3" class="pa-0 pr-2">
                <v-select
                  v-model="searchBy.dbNm"
                  :items="dbNames"
                  :menu-props="{offsetY: true,}"
                  :placeholder="$t('lbl.dbBroker.addDBBrokerDialog.conditionSearch.dbName')"
                  @change="getBrokerQueryInfoList"
                  class="data-table-filter-text-field search-button-data-analysis-table"
                  hide-details
                  dense
                  solo
                ></v-select>
              </v-col>
              <v-col cols="2" class="pa-0 pr-2">
                <v-select
                  v-model="searchBy.queryTp"
                  :items="types"
                  :menu-props="{offsetY: true,}"
                  :placeholder="$t('lbl.dbBroker.addDBBrokerDialog.conditionSearch.type')"
                  @change="getBrokerQueryInfoList"
                  class="data-table-filter-text-field search-button-data-analysis-table"
                  hide-details
                  dense
                  solo
                ></v-select>
              </v-col>
              <v-col cols="4" class="pa-0">
                <v-text-field
                  v-model="searchBy.queryText"
                  :placeholder="$t('lbl.dbBroker.addDBBrokerDialog.conditionSearch.queryText')"
                  @keyup.enter="getBrokerQueryInfoList"
                  class="data-table-filter-text-field search-button-data-analysis-table"
                  heigth="30"
                  outlined
                  hide-details
                  dense
                  solo
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col cols="12" class="pa-0 pt-2">
                <v-data-table
                  :search="searchCodeName"
                  :headers="headerDBBroker"
                  :items="dbBrokerQueryInfoList"
                  :items-per-page="-1"
                  :hide-default-footer="true"
                  :disable-sort="false"
                  class="map-list-table code-list-data-table db-broker-data-table pb-0"
                  fixed-header
                >
                  <template v-slot:header.checkbox>
                    <v-checkbox
                      v-model="checkedAll"
                      @change="selectAllChange"
                      class="select-checkbox-layout-table align-center justify-center"
                      dense
                      hide-details
                      :disabled="dbBrokerData.length === 0 || isDisabledAll"
                    ></v-checkbox>
                  </template>
                  <template v-slot:body="{ items }">
                    <tbody>
                      <tr
                        v-for="(item,index) in items"
                        :key="index"
                        :class="[((selectedRowLinked == item.queryNm) ||(selectedRowLinked == '' && index == 0)) ? 'selected_row' : '']"
                      >
                        <td class="checkbox-col">
                          <v-checkbox
                            v-model="item.checked"
                            @click.native.stop
                            @click.native="selectItemChange($event, item)"
                            class="select-checkbox-layout-table align-center justify-center"
                            dense
                            hide-details
                            :disabled="item.disabled"
                          ></v-checkbox>
                        </td>
                        <td class="code-grp-col no-wrap">{{ item.queryNm }}</td>
                        <td class="code-grp-col no-wrap custom-type-db">{{ item.dbNm }}</td>
                        <td class="code-grp-col no-wrap custom-type-db">{{ item.queryTp }}</td>
                        <td class="code-grp-col no-wrap">{{ item.queryText }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-col>
          <!-- [E]  second table-->
        </v-row>
      </v-col>
    </v-row>
    <v-row class="no-gutters btn-code-section">
      <v-col cols="12" lg="4" class="pa-0 text-right">
        <v-row no-gutters>
          <v-col cols="12" lg="10">
            <v-btn class="btn btn-popup-search btn-popup" color="primary" @click="saveDbBrokerName">
              <!-- <v-icon x-small class="mr-2">fas fa-save</v-icon> -->
              {{$t('btn.common.save')}}
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" lg="8" class="pa-0 text-right">
        <v-btn class="btn btn-delete btn-popup" @click="removeDialog">
          <!-- <v-icon x-small class="mr-2">fas fa-times</v-icon> -->
          {{$t('btn.common.close')}}
        </v-btn>
      </v-col>
    </v-row>
    <dialogWindow
      ref="validateAddDbBroker"
      :detail="$t('msg.dbBroker.warningAddDbBroker')"
      :showCancel="false"
      size="max"
      title="warning"
      color="validation"
    ></dialogWindow>
    <dialogWindow
      ref="confirmDeleteFileDialog"
      :detail="$t('msg.common.deleteConfirm')"
      :dataValue="deleteData"
      :showCancel="true"
      @select-ok="deleteDbBroker($event)"
      color="information"
      size="max"
      title="confirmDialog"
    ></dialogWindow>
    <dialogWindow
      ref="warningDbNameAndType"
      :detail="$t('msg.dbBroker.warningDbNameAndType')"
      :showCancel="false"
      color="validation"
      size="max"
      title="warning"
    ></dialogWindow>
    <dialogWindow
      ref="warningSaveDbBroker"
      :detail="$t('msg.common.require',['DB Broker Name'])"
      :showCancel="false"
      size="max"
      title="warning"
      color="validation"
      @select-ok="focusDbBrokerName($event)"
    ></dialogWindow>
  </dialog-drag>
</template>

<script>
/* globals Store */

import DialogDrag from "@/vue-dlb/components/vue-dialog-drag.vue";
import { mapState } from "vuex";
import dialogWindow from '@/vue-dlb/components/NewDialog.vue'
import $ from "jquery";
import store from '@/store';
import IconSvg from "@/vue-caas/components/IconBase.vue";

// import {
//   showSuccessMessage,
//   showErrorMessage,
//   showProgress,
//   hideProgress,
//   alertSuccess,
//   closeAlert
// } from "@/vue-dlb/utils/sys-util.js";

export default {
  name: "add-code-group-dialog",
  // props: [
  //   "id",
  //   "title",
  //   "options",
  //   "eventCb",
  //   "selectFile",
  //   "closeDialog",
  //   "dragStart",
  //   "dragEnd"
  // ],
  props:{
      id: String,
      title: String,
      options: Object,
      eventCb: Function,
      closeDialog: Function,
      dragStart: Function,
      dragEnd: Function,
      selectFile: String,
      types: Array,
      dbNames: Array
    },
  components: {
    DialogDrag,
    dialogWindow,
    IconSvg
  },
  computed: {
    isBtnActive(){
      return this.selectMasterRows.length > 0 ? false : true;
    },
  },
  data() {
    return {
      checkedAll:false,
      selectedRowLinked: "",
      searchCodeName: "",
      selectMasterRows: [],
      deleteData:'',
      type: '',
      headerDBBroker: [
        { value: "checkbox", text: "", width: "60px",class:"checkbox-col"},
        {
          text: this.$t("tbl.dbBroker.addDBBrokerDialog.queryName"),
          value: "DBBRK_NM",
          width: "150px",
          align: "center"
        },
        {
          text: this.$t("tbl.dbBroker.addDBBrokerDialog.dbName"),
          value: "DB_NM",
          width: "100px",
          align: "center"
        },
        {
          text: this.$t("tbl.dbBroker.addDBBrokerDialog.type"),
          value: "DB_TP",
          width: "50px",
          align: "center"
        },
        {
          text: this.$t("tbl.dbBroker.addDBBrokerDialog.queryText"),
          value: "QUERY_TEXT",
          width: "250px",
          align: "center"
        }
      ],
      dbBrokerQueryInfoList: [],
      dbBrokerData: [],
      dbBrokerName: '',
      addDataItems:{
        ownrId: '',
        compId: '',
        dbbrkNm: '',
        dbNm: '',
        apiMethod: '',
        apiUrl: '',
        dbbrkId: '',
        dbbrkQueryInfo: []
      },
      searchBy: {
        queryNm: '',
        dbNm: '',
        queryTp: '',
        queryText: ''
      },
      dbBrokerDetailList: [],
      selectItemQueryList: [],
      selectedItemIndex: '',
      isDisabledAll: false
    };
  },

  created() {
    this.getBrokerQueryInfoList();
    this.setFocus();
    if(this.options.item.action =='modify'){
      this.getBrokerDetail(this.options.item.selectedRow.DBBRK_ID);
      this.dbBrokerName = this.options.item.selectedRow.DBBRK_NM;
    }
  },

  watch:{
    dbBrokerData() {
      if (this.dbBrokerData.length > 0) {
        let dbNm = this.dbBrokerData[0].dbNm;
        let queryTp = this.dbBrokerData[0].queryTp;
        let dbBrokerQueryInfoList = this.dbBrokerQueryInfoList.filter(item => item.dbNm === dbNm && item.queryTp === queryTp);
        this.isDisabledAll = dbBrokerQueryInfoList.length === this.dbBrokerData.length ? true : false;
      }
    }
  },

  methods: {
    removeDialog(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },
    refreshDialog(dialog){
      dialog.id = this.id;
      this.$emit("refreshData",this.options.item.selectedRow)
      this.closeDialog(dialog);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
    selectItemChange(event, item) {
      console.log("click", item)
      let checked = item.checked;
      if (checked == true) {
        let validationData = this.dbBrokerData.length > 0 ? this.dbBrokerData : this.selectMasterRows;
        validationData.length > 0 ? this.validateDbNameAndType(item, validationData) : this.selectMasterRows.push(item);
      } else if (checked == false) {
        let index = this.findIndexItem(item, this.selectMasterRows, "queryId");
        console.log("index", index)
        if (index != null) {
          this.selectMasterRows.splice(index, 1);
        }
      }
      console.log("checked", this.selectMasterRows)
    },
    selectAllChange(value) {
      let dbNm = this.dbBrokerData[0].dbNm;
      let queryTp = this.dbBrokerData[0].queryTp;

      let selectAllItems = [];
      this.checkedAll = value;
      if (value) {
        this.dbBrokerQueryInfoList.map((item) => {
          if (item.dbNm === dbNm && item.queryTp === queryTp) {
            item.checked = value;
            selectAllItems.push(item);
          }
        })
        this.dbBrokerData.map((element) => {
          selectAllItems = selectAllItems.filter(item => item.queryId !== element.queryId);
        })

        this.selectMasterRows = selectAllItems;
      } else {
        this.dbBrokerQueryInfoList.map((item) => {
          if (item.dbNm === dbNm && item.queryTp === queryTp) {
            selectAllItems.push(item);
          }
        })
        this.dbBrokerData.map((element) => {
          selectAllItems = selectAllItems.filter(item => item.queryId !== element.queryId);
        })
        selectAllItems.map((item) => {
          item.checked = value;
        })
        this.selectMasterRows = [];
      }
    },
    findIndexItem(item, arr, col) {
      let prop = typeof col == "undefined" ? "id" : col;
      let index = arr.findIndex(row => {
        return row[prop] === item[prop];
      });
      return index > -1 ? index : null;
    },
    addDBBroker(){
      if (this.dbBrokerData.length < 1){
        let element;
        for (let index = 0; index < this.selectMasterRows.length; index++) {
          element = this.selectMasterRows[index];
          this.dbBrokerData.push(element);
        }
      }
      else{
        this.dbBrokerData = this.dbBrokerData.concat(this.selectMasterRows);
        console.log("db broker data", this.dbBrokerData)
      }
      this.dbBrokerData.map((item) => {
        let index = this.findIndexItem(item, this.dbBrokerQueryInfoList, "queryId");
        if (index != null) {
          this.$nextTick(()=>{
            this.dbBrokerQueryInfoList[index].disabled = true;
            this.dbBrokerQueryInfoList.splice(index, 1, this.dbBrokerQueryInfoList[index]);
          })
        }
      })
      this.checkedAll = false;
      this.selectMasterRows=[];
    },
    confirmDeleteItem (item) {
      this.deleteData = item;
      this.$refs.confirmDeleteFileDialog.dialog = true;
    },
    saveDbBrokerName(){
      if(this.dbBrokerData.length < 1){
        this.$refs.validateAddDbBroker.dialog = true;
        return;
      }
      else if(this.dbBrokerName.trim() == ''){
          this.$refs.warningSaveDbBroker.dialog = true;
      }
      else {
        this.addDataItems.ownrId = this.$cookies.get('ownr-id');
        this.addDataItems.compId = this.$cookies.get('comp-id');
        this.addDataItems.dbbrkNm = this.dbBrokerName;
        this.addDataItems.dbNm = this.dbBrokerData[0].dbNm;
        let type = this.types.filter(item => item.text === this.dbBrokerData[0].queryTp);
        if (type[0]) {
          this.addDataItems.apiMethod = type[0].value;
        } else {
          this.addDataItems.apiMethod = this.dbBrokerData[0].queryTp;
        }
        console.log("-------dbBrokerData-------", this.dbBrokerData)
        this.dbBrokerData.map((item, index) => {
          this.addDataItems.dbbrkQueryInfo[index]= {
            queryId: item.queryId,
            querySeq: index + 1,
            queryText: item.queryText
          }
        });
        if (this.options.item.action =="add") {
          console.log("----------------Add DB Broker----------", this.addDataItems)
          this.$store.dispatch('addDbBroker', this.addDataItems).then(() => {
            this.refreshDialog({});
          });
        } else {
          this.addDataItems.dbbrkId = this.options.item.selectedRow.DBBRK_ID;
          console.log("----------------Modify DB Broker----------", this.addDataItems)
          this.$store.dispatch('modifyDbBroker', this.addDataItems).then(() => {
            this.refreshDialog({});
          });
        }
      }
    },
    setFocus() {
      setTimeout(() => {
        this.$refs.dbBrokerName.focus();
      }, 300);
    },
    /*
    * 2021.22.06 203737 SPKA-145 issue 92 DB Broker Development - Add/ Modify Popup Screen
    */
    getBrokerQueryInfoList() { 
      this.$store.dispatch('getBrokerQueryInfoList', this.searchBy).then(() => {
        this.dbBrokerQueryInfoList = this.$store.getters.dbBrokerQueryInfoList;
        console.log("-------------Before getBrokerQueryInfoList-----------------", this.dbBrokerQueryInfoList);
        this.dbBrokerQueryInfoList.map((itemBroker, index) => {
          let queryType = this.getConvertQueryType(itemBroker);
          this.dbBrokerQueryInfoList[index].queryTp = queryType;
        });
        console.log("-------------After getBrokerQueryInfoList-----------------", this.dbBrokerQueryInfoList);
        this.reloadDbBrokerListDisabled();
      });
    },
    validateDbNameAndType(itemChecked, selectMasterRows) {
      console.log("----------validateDbNameAndType------",itemChecked, selectMasterRows)
      let isValidate = false;
      selectMasterRows.map(item => {
        if (itemChecked.dbNm !== item.dbNm || itemChecked.queryTp !== item.queryTp) {
          this.$refs.warningDbNameAndType.dialog = true;
          isValidate = true;
          itemChecked.checked =false;
          return;
        }
      })
      if (!isValidate) {
        this.selectMasterRows.push(itemChecked);
      }
    },
    deleteDbBroker(item) {
      let indexDisabled = this.findIndexItem(item, this.dbBrokerQueryInfoList, "queryId");
      if (indexDisabled != null) {
        this.dbBrokerQueryInfoList[indexDisabled].disabled = false;
        this.dbBrokerQueryInfoList[indexDisabled].checked = false;
        this.dbBrokerQueryInfoList.splice(indexDisabled, 1, this.dbBrokerQueryInfoList[indexDisabled]);
      }

      let index = this.findIndexItem(item, this.dbBrokerData, "queryId");
      if (index != null) {
        this.dbBrokerData.splice(index, 1);
      }
    },
    getConvertQueryType(itemBroker) {
      let convertType = '';
      let type = this.types.filter(itemType => itemType.value === itemBroker.queryTp);
      if (type[0]) {
        convertType = type[0].text;
      }
      return convertType;
    },
    getBrokerDetail(brokerId) {
      this.$store.dispatch('getBrokerDetail', {brokerId: brokerId}).then(() => {
        this.dbBrokerDetailList = this.$store.getters.dbBrokerDetailList;
        this.dbBrokerData = this.dbBrokerDetailList;
        this.dbBrokerData.map((item, index) => {
        this.dbBrokerData[index].queryTp = this.getConvertQueryType(item);
        let indexDisabled = this.findIndexItem(item, this.dbBrokerQueryInfoList, "queryId");
        if (indexDisabled != null) {
          this.dbBrokerQueryInfoList[indexDisabled].disabled = true;
          this.dbBrokerQueryInfoList[indexDisabled].checked = true;
          this.dbBrokerQueryInfoList.splice(indexDisabled, 1, this.dbBrokerQueryInfoList[indexDisabled]);
        }
      });
        console.log("-------------getBrokerDetail-----------------", this.dbBrokerDetailList);
      });
    },
    moveUpQuery() {
      let selectedItem = this.selectItemQueryList[0];
      if (selectedItem) {
        let index = this.findIndexItem(selectedItem, this.dbBrokerData, "queryId");
        if (index != null && index > 0) {
          this.swap(this.dbBrokerData, index, index - 1);
          this.selectedItemIndex = index - 1;
        }
      }
      console.log("---------------MoveUpQuery---------", this.dbBrokerData);
    },
    moveDownQuery() {
      let selectedItem = this.selectItemQueryList[0];
      let dbBrokerDataLength = this.dbBrokerData.length;
      if (selectedItem) {
        let index = this.findIndexItem(selectedItem, this.dbBrokerData, "queryId");
        if (index != null && index < dbBrokerDataLength - 1) {
          this.swap(this.dbBrokerData, index, index + 1);
          this.selectedItemIndex = index + 1;
          
        }
      }
      console.log("---------------MoveDownQuery---------", this.dbBrokerData);
    },
    selectItemQuery(item) {
      if (this.selectItemQueryList.length > 0) {
        this.selectItemQueryList[0].queryId !== item.queryId ?
        this.selectItemQueryList.splice(0, 1, item) :
        this.selectItemQueryList.pop();
      } else {
        this.selectItemQueryList.push(item);
      }
      console.log("---------selectItemQuery--------", item, this.selectItemQueryList)
    },
    swap(dbBrokerData, index1, index2) {
      var temp = dbBrokerData[index2];
      dbBrokerData.splice(index2, 1, dbBrokerData[index1]);
      dbBrokerData.splice(index1, 1, temp);
    },
    focusDbBrokerName() {
      this.setFocus();
    },
    reloadDbBrokerListDisabled() {
      let dbBrokerData = JSON.parse(JSON.stringify(this.dbBrokerData.concat(this.selectMasterRows)));
      dbBrokerData.map((item) => {
        let indexDisabled = this.findIndexItem(item, this.dbBrokerQueryInfoList, "queryId");
        if (indexDisabled != null) {
          this.dbBrokerQueryInfoList[indexDisabled].disabled = true;
          this.dbBrokerQueryInfoList[indexDisabled].checked = true;
          this.dbBrokerQueryInfoList.splice(indexDisabled, 1, this.dbBrokerQueryInfoList[indexDisabled]);
        }
      });
    }
  }
};
</script>
<style lang="scss">
.add-code-dialog .data-section {
  height: 600px;
}
.btn-code-section{
  height: 30px;
  margin-top:10px;
}
.code-table-grid {
  box-sizing: border-box;
  border-radius: 3px;
  padding: 15px 15px 10px 15px !important;
}
.btn-add-code-row {
  text-align: center !important;
  margin: auto !important;
  display: inline-block;
  padding:0 10px !important;
}
.btn-add-code-row .v-btn.v-btn--contained.btn-add-code{
  padding: 0;
  min-width: 28px !important;
  max-width: 28px !important;
  height: 37px !important;
}
.map-list-table.db-broker-data-table .v-data-table__wrapper {
  overflow-y: auto;
  max-height: 485px;
  min-height: 530px;
  overflow-x: auto;
}
.maplist-layout-dialog .v-data-table.code-list-data-table thead tr:last-child {
  th {
    height: 25px !important;
    i.mdi.mdi-arrow-up {
    font-size: 14px !important;
    }
  }
  th.checkbox-col {
    i.mdi.mdi-arrow-up  {
    display: none;
    }
  }
  th.sortable:hover,th.sortable.active {
    color: #000000;
  }
}
.maplist-layout-dialog .v-data-table.code-list-data-table {
  .v-icon.v-icon--dense  {
    font-size: 14px;
  }
}
.group-code-link{
  text-decoration: underline;
  font-size: 13px;
  font-weight: bold
}
.code-group-list.v-list .fas.fa-times {
  color: #CD5F5F;
}
.code-group-list.v-list .fas.fa-circle{
  font-size:8px !important;
}
.code-group-list.v-list .v-list-item__icon:first-child {
    margin-right: 8px;
}
.code-group-list.v-list .v-list-item__icon:last-of-type:not(:only-child) {
    margin-left: 24px;
}
.code-group-label{
  font-size: 16px;
  font-weight:bold;
}
.vuebar-element {
    max-height: 345px;
    overflow-y: auto;
    width: 100%
}
.vuebar-element::-webkit-scrollbar {
      width: 8px;
}
.vuebar-element::-webkit-scrollbar-thumb{
  border-radius: 10px;
}
.theme--dark {
  .code-group-label{
    color:#C6CACC
  }
  .code-list-data-table.v-data-table tbody tr.selected_row {
    background: #243645 !important;
  }
  .vuebar-element .v-list{
   background: #232329;
  }
  .vuebar-element::-webkit-scrollbar-track  {
    background-color: #595B64;
  }
  .vuebar-element::-webkit-scrollbar-thumb {
    background-color: #DEDFE0;
  }
  .vuebar-element::-webkit-scrollbar-corner{
    background-color: #595B64;
  }
  // .code-list-data-table .v-data-table__wrapper {
  //   background: transparent;
  // }
  .code-table-grid {
    background-color: #232329;
    border: 1px solid #5f616d;
  }
  .code-group-list.v-list .v-list-item--active {
    cursor: default;
    color: white;
    background:#243645 !important;
  }
}
.theme--light{
  .code-list-data-table.v-data-table tbody tr.selected_row {
    background: #eaf1f8  !important;
  }
  .vuebar-element{
    background: #FFFFFF;
  }
  .vuebar-element .v-item--active {
      background: #eaf1f8  !important;
  }
  .vuebar-element::-webkit-scrollbar-track  {
    background-color: #FFFFFF;
  }
  .vuebar-element::-webkit-scrollbar-corner  {
    background-color: #FFFFFF;
  }
  .vuebar-element::-webkit-scrollbar-thumb {
      background-color: #c1c1c1;
  }
  // .code-list-data-table .v-data-table__wrapper {
  //   background: #FFFFFF;
  // }
  .code-table-grid {
    background-color: #FAFCFF;
    border: 1px solid #F0F7FB;
  }
}
.map-list-table.db-broker-data-table td{
  text-align: left !important;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.vuebar-element.db-broker-left-panel {
  min-height: 450px;
  max-height: 450px;
}
/* .theme--dark.v-data-table.v-data-table--fixed-header.code-list-data-table thead tr:last-child th{
  border-bottom: none !important;
} */
</style>